export default "__VITE_ASSET__f62a7311__"